import localForage from 'localforage';

// https://github.com/rt2zz/redux-persist#api

export default {
    storage: localForage,
    whitelist: ['session', 'igSession'],
};
